import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class LocalizedTitleStrategy extends TitleStrategy {
  private latestSnapshot?: RouterStateSnapshot

  constructor(
    private readonly pageTitle: Title,
    private readonly translate: TranslateService
  ) {
    super()
    this.translate.onLangChange.subscribe(() => this.applyLatestTitle())
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.latestSnapshot = snapshot
    this.applyLatestTitle()
  }

  private applyLatestTitle(): void {
    if (!this.latestSnapshot) return

    const title = this.buildTitle(this.latestSnapshot)
    if (!title) return

    this.translate.get(title).subscribe((translatedTitle) => {
      this.pageTitle.setTitle(translatedTitle)
    })
  }
}
